import React, { useEffect, useState } from "react";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Field } from "redux-form";
import { renderCheckboxField } from "../../../../../utils/renderField";
import Show from "../../../../../utils/show.component";

export const AuthAchScheduledPaymentDatePicker = ({ scheduledPaymentDate, change, disabled }) => {
  const [show, setShow] = useState(false);

  const buttonColor = disabled ? "#c1c1c1" : "#00558c";

  useEffect(() => {
    if (disabled) {
      setShow(false);
      change("ScheduledPaymentDate", moment().toDate());
    }
  }, [disabled]);

  return (
    <div>
      <div className="mb-1 bold f18">Select Payment Date</div>
      <div className="mb-4">Your payment will be made on this day.</div>
      <div className="mb-3">
        <button
          className="d-flex p-2"
          style={{ color: "white", backgroundColor: buttonColor, width: "240px" }}
          type="button"
          onClick={() => setShow((state) => !state)}
          disabled={disabled}
        >
          <i className="material-icons pl-1 pr-5">calendar_month</i>
          {moment(scheduledPaymentDate).format("ddd, M/D")}
        </button>
      </div>
      <Show condition={show}>
        <div className="mb-3">
          <DatePicker
            selected={scheduledPaymentDate}
            name="ScheduledPaymentDate"
            id="ScheduledPaymentDate"
            onChange={(date) => {
              change("ScheduledPaymentDate", date);
              setShow(false);
            }}
            minDate={moment().toDate()}
            maxDate={moment().add(14, "d").toDate()}
            placeholderText="Select a date"
            data-e2e-id="scheduledPaymentDatePicker"
            inline
          />
        </div>
      </Show>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/payment-forms/field-components/general/auth-ach-scheduled-payment-datepicker.component.js